import React, { useState, useEffect, useCallback } from 'react';
import { View, Text, Switch, StyleSheet, Platform } from 'react-native';

export function NotificationToggle() {
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    // Check if the browser supports notifications
    if ('Notification' in window) {
      setIsSupported(true);
      setNotificationsEnabled(Notification.permission === 'granted');
    }
  }, []);

  const handleNotificationToggle = async (value: boolean) => {
    if (value) {
      if (!('Notification' in window)) {
        alert('This browser does not support notifications.');
        setNotificationsEnabled(false);
        return;
      }

      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        setNotificationsEnabled(true);
      } else {
        setNotificationsEnabled(false);
      }
    } else {
      // Browsers don't allow revoking permission programmatically once granted
      // but we can update our local state
      setNotificationsEnabled(false);
    }
  };

  if (!isSupported) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Text style={styles.label}>Allow Web Notifications</Text>
      <Switch
        value={notificationsEnabled}
        onValueChange={handleNotificationToggle}
        trackColor={{ false: '#767577', true: '#5390AB' }}
        thumbColor={Platform.OS === 'ios' ? undefined : '#fff'}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#F8F9FA',
    paddingVertical: 15,
    paddingHorizontal: 15,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#F0F0F0',
    marginBottom: 20,
  },
  label: {
    fontSize: 16,
    color: '#555',
  },
});
